import {
	GET_BILLING_CHARACTER_COUNT,
	GET_BILLING_CHARACTER_COUNT_CLEAR,
	GET_BILLING_CHARACTER_COUNT_FAIL,
	GET_BILLING_CHARACTER_COUNT_SUCCESS,
	GET_BILLING_USER_LOGIN_DETAILS,
	GET_BILLING_USER_LOGIN_DETAILS_CLEAR,
	GET_BILLING_USER_LOGIN_DETAILS_FAIL,
	GET_BILLING_USER_LOGIN_DETAILS_SUCCESS,
	SET_PAGE_NUMBER_CHAR_COUNT,
	SET_PAGE_NUMBER_USER_LOGIN_DETAILS,
} from "../types"

const initialState = {
	characterCountLoading: false,
	userLoginDetailsLoading: false,
	error: false,
	characterCount: [],
	totalCharacterCount: 0,
	userLoginDetails: [],
	totalUserLoginDetails: 0,
	pageNumberCharCount: 1,
	pageNumberUserLoginDetails: 1,
}

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_BILLING_CHARACTER_COUNT:
			return {
				...state,
				characterCountLoading: true,
			}
		case GET_BILLING_CHARACTER_COUNT_SUCCESS:
			return {
				...state,
				characterCountLoading: false,
				totalCharacterCount: action?.payload?.total_records,
				characterCount: action?.payload?.data || [],
			}
		case GET_BILLING_CHARACTER_COUNT_FAIL:
			return {
				...state,
				characterCountLoading: false,
			}
		case GET_BILLING_CHARACTER_COUNT_CLEAR:
			return {
				...state,
				characterCountLoading: false,
				characterCount: [],
				totalCharacterCount: 0,
			}
		case GET_BILLING_USER_LOGIN_DETAILS:
			return {
				...state,
				userLoginDetailsLoading: true,
			}
		case GET_BILLING_USER_LOGIN_DETAILS_SUCCESS:
			return {
				...state,
				userLoginDetailsLoading: false,
				userLoginDetails: action?.payload?.data || [],
				totalUserLoginDetails: action?.payload?.total_records,
			}
		case GET_BILLING_USER_LOGIN_DETAILS_FAIL:
			return {
				...state,
				userLoginDetailsLoading: false,
			}
		case GET_BILLING_USER_LOGIN_DETAILS_CLEAR:
			return {
				...state,
				userLoginDetailsLoading: false,
				userLoginDetails: [],
				totalUserLoginDetails: 0,
			}
		case SET_PAGE_NUMBER_USER_LOGIN_DETAILS:
			return {
				...state,
				pageNumberUserLoginDetails: action?.payload,
			}
		case SET_PAGE_NUMBER_CHAR_COUNT:
			return {
				...state,
				pageNumberCharCount: action?.payload,
			}
		default:
			return state
	}
}
